<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-item'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('artist')}`"
    @menuClick="onRightMenuClick"
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <!-- :rightMenu="[...rightMenu]" -->
    <NTable
      class="dbox1"
      id="distribution-statement-item"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('item')">
            <span>{{ item["item"] }}</span>
          </td>
          <td v-bind="tdcon('artist')">
            <span>{{ item["artist"] }}</span>
          </td>
          <td v-bind="tdcon('title1')">
            <span>{{ item["title"] }}</span>
          </td>

          <td v-bind="tdcon('total')">
            <span>{{ item["total"] }}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { distributionAccountListLDTRoutes } from "../../router/routes";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";

export default {
  props: {
    selectedStatementDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("item", {}),
        createTableHeader("title1", { text: "title" }),
        createTableHeader("artist", {}),
        createTableHeader("total", { ta: "right" }),
      ];
    },

    invoice_id: function () {
      return this.selectedStatementDetails?.statement?.invoice_id || "";
    },

    list: function () {
      return this.selectedStatementDetails.items || [];
    },
    rightMenu: function () {
      if (this.invoice_id == "") {
        return [
          {
            text: this.$t("invoice_statement"),
            value: "invoice_statement",
          },
          {
            text: this.$t("refresh"),
            value: "refresh",
          },
        ];
      } else {
        return [
          {
            text: this.$t("open_related_invoice"),
            value: "open_related_invoice",
          },
        ];
      }
    },
  },
  methods: {
    onRightMenuClick: async function (menu) {
      switch (menu) {
        case "invoice_statement": {
          const { account_id } = this.selectedStatementDetails.statement;

          this.$router.push({
            name: distributionAccountListLDTRoutes.names.tab,
            params: {
              account_id: account_id,
              tab: "current_statements",
            },
          });

          break;
        }
        case "refresh": {
        }
        case "open_related_invoice": {
          this.$router.push({
            name: invoiceListLDTRoutes.names.tab,
            params: {
              invoice_id: this.invoice_id,
              tab: "overview",
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-statement-sidewindow-item {
  .dt-ntable tbody tr:last-child {
    border-bottom: 0;
  }
}
</style>
